const desktopNavMenuButtons = document.querySelectorAll(
  "#primary-menu .menu-item-has-children .mega-menu-one__button"
);
const desktopNavHeader = document.querySelector(".site-header");

const toggleDesktopMenuItem = (navButton) => {
  const buttonListElement = navButton.closest(".menu-item-has-children");
  const itemMegaMenu = buttonListElement.querySelector(".mega-menu-one");

  if (!buttonListElement || !itemMegaMenu) return;

  desktopNavMenuButtons.forEach((otherNavButton) => {
    const otherButtonListElement = otherNavButton.closest(
      ".menu-item-has-children"
    );
    const otherItemMegaMenu =
      otherButtonListElement.querySelector(".mega-menu-one");

    if (otherButtonListElement !== buttonListElement) {
      otherButtonListElement.classList.remove("open");
      otherItemMegaMenu.setAttribute("data-open", "false");
      desktopNavHeader.classList.remove("mega-menu-open");
    }
  });

  buttonListElement.classList.toggle("open");
  const isOpen = itemMegaMenu.getAttribute("data-open") === "true";
  const searchIcon = document.querySelector(".navbar-one__search-btn");
  itemMegaMenu.setAttribute("data-open", isOpen ? "false" : "true");

  if (itemMegaMenu.dataset.open === "true") {
    document.body.classList.remove("navSearchOpen");
    searchIcon.classList.remove("close");
    desktopNavHeader.classList.add("mega-menu-open");
  } else {
    desktopNavHeader.classList.remove("mega-menu-open");
  }
};

desktopNavMenuButtons.forEach((navItemButton) => {
  navItemButton.addEventListener("mouseover", (e) => {
    if (!navItemButton.parentNode.classList.contains("open")) {
      e.preventDefault();
      toggleDesktopMenuItem(navItemButton);
    }
  });

  // navItemButton.addEventListener("focus", (e) => {
  //   if (!navItemButton.parentNode.classList.contains("open")) {
  //     e.preventDefault();
  //     toggleDesktopMenuItem(navItemButton);
  //   }
  // });

  // navItemButton.addEventListener("click", (e) => {
  //   toggleDesktopMenuItem(navItemButton);
  // });
});

desktopNavMenuButtons.forEach((navItemButton) => {
  const menuDropdown = navItemButton.nextElementSibling;
  if (menuDropdown) {
    menuDropdown.addEventListener("focusout", (e) => {
      // Check if the mouse is still within the menuDropdown element
      if (!menuDropdown.contains(e.relatedTarget)) {
        e.preventDefault();
        toggleDesktopMenuItem(navItemButton);
      }
    });
    menuDropdown.addEventListener("mouseout", (e) => {
      // Check if the mouse is still within the menuDropdown element
      if (!menuDropdown.contains(e.relatedTarget)) {
        e.preventDefault();
        toggleDesktopMenuItem(navItemButton);
      }
    });
  }
});

// search button logic
const searchButton = desktopNavHeader?.querySelector(".navbar-one__search-btn");

if (searchButton) {
  searchButton.addEventListener("click", () => {
    document.body.classList.toggle("navSearchOpen");
    const searchInput = document.querySelector(".search-field");
    const hamburgerMenu = document.querySelector(".navbar-one__hamburger");
    const menuDropdowns = document.querySelectorAll(".navbar-one__top-level");

    searchButton.classList.toggle("close");

    menuDropdowns.forEach((dropdown) => {
      const menuDropdown = dropdown.querySelector(".mega-menu-one");
      menuDropdown?.removeAttribute("data-open");
      dropdown.classList.remove("open");
    });

    document.body.classList.remove("overflow-hidden");
    const mobileMenu = document.querySelector(".navbar-one__mobile");
    const desktopMenu = document.querySelector(".navbar-one__desktop");

    mobileMenu?.removeAttribute("data-open");
    desktopMenu?.removeAttribute("data-open");
    hamburgerMenu.classList.remove("menu-open");
    desktopNavHeader.classList.remove("mega-menu-open");
    desktopNavHeader.classList.remove("mobile-menu-open");

    if (document.body.classList.contains("navSearchOpen")) {
      searchInput.focus();
    }
  });
}
